import { Button, Stack } from "@mui/material";
import { useEffect } from "react";
import { Outlet } from "react-router";
import AuthorizedBox from "@entrilia/shared/components/AuthorizedBox";
import NoAccessPage from "@entrilia/shared/components/NoAccessPage";
import EditableTitle from "../../common/EditableTitle";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import CanvasEdit from "./CanvasEdit";
import WidgetSettings from "./components/widgets-toolbox/WidgetSettings";
import WidgetsToolbar from "./components/widgets-toolbox/WidgetsToolbar";
import { useDashboardContext } from "./contexts/DashboardContext";

const DashboardPageEdit = () => {
  const {
    dashboard,
    tileObjects,
    updating,
    addNewTile,
    updateTileLayout,
    updateTile,
    save,
    saveDashboardName,
    setIsEditMode,
  } = useDashboardContext();

  useEffect(() => {
    setIsEditMode(true);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, []);

  return (
    <AuthorizedBox permissions={["ManageDashboards"]} NotAuthorizedComponent={<NoAccessPage />}>
      <GeneralPageHeader
        TitleComponent={
          <EditableTitle
            title={dashboard?.nameUserInput ?? ""}
            tooltip="Rename Dashboard"
            onTitleChanged={saveDashboardName}
            placeholder="Enter Dashboard Name"
          />
        }
        showDefaultBackButtonTo="../.."
      >
        <Button
          variant="contained"
          color="primary"
          disabled={updating.inProgress}
          loading={updating.inProgress}
          onClick={save}
        >
          Save
        </Button>
      </GeneralPageHeader>
      <Stack direction="row" sx={{ flex: 1 }}>
        <Stack sx={{ flex: 1, backgroundColor: "background.grey" }}>
          <CanvasEdit
            tiles={tileObjects}
            onNewTile={addNewTile}
            onLayoutChange={updateTileLayout}
            onTileUpdate={updateTile}
          />
        </Stack>
        <Stack
          sx={{
            flex: 1,
            maxWidth: "400px",
            borderLeft: "1px solid",
            borderColor: "divider",
            position: "relative",
          }}
        >
          <WidgetsToolbar />
          <WidgetSettings />
        </Stack>
      </Stack>
      <Outlet />
    </AuthorizedBox>
  );
};

export default DashboardPageEdit;
